function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStarRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.052 12.05l-7.748-1.064-3.305-7.339c-.388-.863-1.609-.863-1.998 0l-3.303 7.34-7.75 1.063c-.898.123-1.267 1.227-.624 1.87l5.714 5.702-1.432 8.083c-.162.92.817 1.612 1.624 1.148L16 24.96l6.771 3.893c.807.464 1.786-.229 1.624-1.148l-1.432-8.083 5.713-5.703c.644-.642.274-1.746-.624-1.869z",
    fill: props.color
  }));
}

export default SvgIconStarRexFilled;